import React from 'react'
import PropTypes from 'prop-types'

import PermissionScopeChip from '../PermissionScopeChip'
import { columnShape } from '../../propTypes'
import styles from './styles'

const PermissionMatrixHeaderChipCell = ({ column }) => {
  const useStyles = styles(column.width)
  const classes = useStyles()

  return (
    <div className={classes.chipCell}>
      <PermissionScopeChip label={column.label} color={column.color} />
    </div>
  )
}

PermissionMatrixHeaderChipCell.propTypes = {
  column: columnShape.isRequired,
}

export default PermissionMatrixHeaderChipCell
